import debounce from "./utils/debounce.js";
export default () => ({
  activeDropdownIndex: null,
  gridClass: "product-grid-large",
  scrollTop: 0,
  isMobile: null,
  initFunction(gridSetting) {
    if (gridSetting === "8") {
      this.gridClass = "product-grid-8";
    }
    this.toggleIconOpacity(this.$refs.gridIconWrapper);
    this.toggleIconOpacity(this.$refs.gridIconWrapperMobile);
    this.handleResize();
    this.updateUspsHeight();
    this.$watch("activeDropdownIndex", () => {
      const activeIndex = this.activeDropdownIndex;
      const container = this.$refs.container;

      if (!isNaN(activeIndex)) {
        container.querySelectorAll(".facet").forEach((item) => {
          item.style.display = "none";
        });
        const activeFacet = container.querySelector(
          `.facet[data-index="desktop-${activeIndex}"]`
        );

        if (activeFacet) {
          // Possible a bug here, sometimes activeFacet becomes an PointerEvent (found on search page)
          activeFacet.style.display = "";
        }
        const scrollHeight = container.scrollHeight;
        container.style.maxHeight = `${scrollHeight}px`;
      } else {
        container.style.maxHeight = activeIndex ? scrollHeight : "";
      }
    });
  },
  updateUspsHeight() {
    const uspBar = document.getElementById("shopify-section-usp-bar");
    const header = document.getElementById("shopify-section-header");

    const uspBarHeight = uspBar ? uspBar.clientHeight : 0;
    const headerHeight = header ? header.clientHeight : 0;

    // Calculate the combined height
    const combinedHeight = uspBarHeight + headerHeight;

    // Set the combined height in a CSS variable
    document.documentElement.style.setProperty(
      "--usps-height-combined",
      `${combinedHeight}px`
    );
  },

  onScroll() {
    const topOffset = window.scrollY;
    // desktop variables:
    const filterbarDesktop = this.$refs.filterbarDesktop;
    const desktopTop = filterbarDesktop.getBoundingClientRect().top;
    const hasStyleDesktop =
      filterbarDesktop.firstElementChild.classList.contains("sticky-menu");
    const placeholderDesktop = document.querySelector(".facet-placeholder");
    const menuHeightDesktop = desktopTop <= 40;
    const container = this.$refs.container;
    // mobile variables:
    const filterbarMobile = this.$refs.filterbarMobile;
    const mobileTop = filterbarMobile.parentElement.getBoundingClientRect().top;
    const hasStyleMobile = filterbarMobile.classList.contains("sticky-menu");
    const placeholderMobile = document.querySelector(
      ".facet-placeholder-mobile"
    );
    const menuHeightMobile = mobileTop <= 40;
    if (!this.isMobile) {
      // desktop scroll up/down
      if (desktopTop <= 0) {
        placeholderDesktop.style.display = "block";
        // if scroll direction is up
        if (topOffset < this.scrollTop) {
          filterbarDesktop.firstElementChild.classList.add("show-sticky-menu");
          // if scroll direction is down
        } else if (topOffset > this.scrollTop) {
          filterbarDesktop.firstElementChild.classList.remove(
            "show-sticky-menu"
          );
          container.style.maxHeight = "";
          container.querySelectorAll(".facet").forEach((item) => {
            item.style.display = "none";
          });
          this.activeDropdownIndex = null;
        }
      }
      // desktop add/remove sticky
      if (desktopTop <= 0 && !hasStyleDesktop) {
        filterbarDesktop.firstElementChild.classList.add("sticky-menu");
      } else if (!menuHeightDesktop && hasStyleDesktop) {
        filterbarDesktop.firstElementChild.classList.remove("sticky-menu");
        filterbarDesktop.firstElementChild.classList.remove("show-sticky-menu");
        placeholderDesktop.style.display = "none";
      }
    }
    if (this.isMobile) {
      // mobile scroll up/down
      if (mobileTop <= 0) {
        placeholderMobile.style.display = "block";
        // if scroll direction is up
        if (topOffset < this.scrollTop) {
          // Check if the user has scrolled to the bottom
          if (!this.isScrolledToBottom(40)) {
            filterbarMobile.classList.add("show-sticky-menu");
          }

          // if scroll direction is down
        } else if (topOffset > this.scrollTop) {
          filterbarMobile.classList.remove("show-sticky-menu");
        }
      }
      // mobile add/remove sticky
      if (mobileTop <= 0 && !hasStyleMobile) {
        filterbarMobile.classList.add("sticky-menu");
      } else if (!menuHeightMobile && hasStyleMobile) {
        filterbarMobile.classList.remove("sticky-menu");
        filterbarMobile.classList.remove("show-sticky-menu");
        placeholderMobile.style.display = "none";
      }
    }
    this.scrollTop = topOffset <= 0 ? 0 : topOffset;
  },
  handleResize() {
    const filterbarDesktop = this.$refs.filterbarDesktop;
    const desktopTop = filterbarDesktop.getBoundingClientRect().top;
    const hasStyleDesktop =
      filterbarDesktop.firstElementChild.classList.contains("sticky-menu");
    const placeholderDesktop = document.querySelector(".facet-placeholder");
    const menuHeightDesktop = desktopTop <= 40;
    if (window.innerWidth > 1023) {
      if (!menuHeightDesktop && hasStyleDesktop) {
        filterbarDesktop.firstElementChild.classList.remove("sticky-menu");
        filterbarDesktop.firstElementChild.classList.remove("show-sticky-menu");
        placeholderDesktop.style.display = "none";
      }
    }
    if (window.innerWidth < 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  toggleDesktopFacet(index) {
    if (this.activeDropdownIndex == index) {
      this.activeDropdownIndex = null;
      return;
    }
    this.activeDropdownIndex = index;
  },
  closeFilters() {
    this.activeDropdownIndex = null;
    return;
  },
  toggleIconOpacity(ref) {
    Object.values(ref.children).map((child) => {
      child.firstElementChild.style.strokeOpacity = "1";
      if (!child.classList.contains(this.gridClass)) {
        child.firstElementChild.style.strokeOpacity = "0.3";
      }
    });
  },
  toggleGridColumns(className) {
    this.gridClass = className;
    const productGrid = document.getElementById("ProductGridContainer");
    productGrid.className = className;
    this.toggleIconOpacity(this.$refs.gridIconWrapper);
    this.toggleIconOpacity(this.$refs.gridIconWrapperMobile);
    this.$dispatch("cta-order", className);
  },
  isScrolledToBottom(threshold) {
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    let scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    return scrollTop + clientHeight + threshold >= scrollHeight;
  },
});
